import api from "@/api.js";

export default {
  state: {
    locations: [],
    locationsLoading: false
  },
  mutations: {
    setLocations(state, payload) {
      state.locations = payload;
    },
    setLocationsLoading(state, loading) {
      state.locationsLoading = loading;
    }
  },
  actions: {
    async loadLocations({ commit, state }) {
      commit("setLocationsLoading", true);
      let locations = await api.get("locations");
      commit("setLocations", locations.data);
      commit("setLocationsLoading", false);
    },
    async saveLocation({ commit, dispatch }, payload) {
      let returnData;
      await api
        .put("locations", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });
      dispatch("loadLocations");
      return returnData;
    },
    async newLocation({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post("locations", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result,
            id: result.data.locations_id
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });

      return returnData;
    }
  },
  getters: {
    locations(state) {
      return state.locations;
    },
    locationsLoading(state) {
      return state.locationsLoading;
    }
  }
};
